import axios from 'axios';
import store from '@/store';
import HelperS from '@/shared-modules/services/helper.service';
import { smallNotification } from '@shared/services/gf.notification.service';
import qs from 'qs';

export default {
  getVerifiedCompanies(params) {
    return axios
      .get(`/api/admin/company/verified`, {
        params: { ...HelperS.getRealPagination(params || {}) }
      })
      .then((res) => {
        store.dispatch('setVerifiedCompanies', HelperS.parsePagination(res.data));
        return HelperS.parsePagination(res.data);
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        console.error(err);
      });
  },
  getPinnedCompanies() {
    return axios
      .get(`/api/admin/partner/all`)
      .then((res) => {
        store.dispatch('setPinnedCompanies', res.data._embedded.partnerCompanyModelList);
        return res.data._embedded.partnerCompanyModelList;
      })
      .catch((err) => {
        console.error('No pinned companies');
        store.dispatch('setPinnedCompanies', null);
      });
  },
  pinVerifiedCompany(companyUuid, projectUuid) {
    return axios
      .post(`/api/admin/partner/pin`, qs.stringify({ companyUuid, projectUuid }))
      .then((res) => {
        smallNotification('success', { title: 'Компания успешно закреплена!' });
        this.getPinnedCompanies();
        return res.data;
      })
      .catch((err) => {
        smallNotification('info', { title: 'Можно закрепить не более 5 компаний!' });
        console.error(err);
      });
  },
  changeVerifiedCompanyProject(companyUuid, projectUuid) {
    return axios
      .post(`/api/admin/partner/change-project`, qs.stringify({ companyUuid, projectUuid }))
      .then((res) => {
        smallNotification('success', { title: 'Проект успешно изменен!' });
        this.getPinnedCompanies();
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        console.error(err);
      });
  },
  unpinVerifiedCompany(companyUuid) {
    return axios
      .delete(`/api/admin/partner/pin`, {
        params: { companyUuid }
      })
      .then((res) => {
        smallNotification('info', { title: 'Компания откреплена' });
        this.getPinnedCompanies();
        return res.data;
      })
      .catch((err) => {
        smallNotification('danger', { title: 'Произошла ошибка' });
        console.error(err);
      });
  },
  getCurrentCompanyInfo(companyUuid) {
    return axios
      .get(`/api/admin/partner/get-partner/${companyUuid}`)
      .then((res) => {
        store.dispatch('setSelectedCompany', res.data);
        return res;
      })
      .catch((err) => {
        store.dispatch('setSelectedCompany', null);
      });
  },
  savePinnedCompaniesOrder(companiesList, emptyFlag) {
    if (emptyFlag) {
      smallNotification('warning', { title: 'Закрепленные компании отсутствуют'});
      return;
    }
    return axios
      .post(`/api/admin/partner/save-order`, companiesList)
      .then((res) => {
        store.dispatch('setPinnedCompanies', companiesList);
        smallNotification('success', { title: 'Порядок отображения сохранен!' });
        return res.data;
      })
      .catch((err) => {
        console.error(err);
      });
  },
  setDefaultCover(companyUuid) {
    return axios
      .delete(`/api/admin/company/${companyUuid}/cover`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  setCompanyDefaultCoverAdmin(companyUuid) {
    return axios
      .delete(`/api/admin/company/${companyUuid}/cover`)
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  }
};
